module.exports = __webpack_public_path__ + "img/lantern.abf0819a.svg";